import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-wa-select',
	templateUrl:'./WaSelectPage.html',
	styles: [],
	styleUrls:['./WaSelectPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class WaSelectPage
{
	mdContent_445 = `\`\`\`java
import com.jwebmp.webawesome.components.select.WaSelect;
\`\`\``;
	mdContent_446 = `\`\`\`java
new WaSelect<>()
\`\`\``;
	mdContent_447 = `\`\`\`java
var sel = new WaSelect<>();
sel.setLabel("Country");
sel.setPlaceholder("Choose...");
sel.add(new WaSelectOption<>("us", "United States"));
sel.add(new WaSelectOption<>("uk", "United Kingdom"));
\`\`\``;
}
